import { useSelector } from 'react-redux'
import { selectTranslations } from '../../../services/i18n/i18nSlice'
import { Form, InputGroup, Tab, Tabs } from "react-bootstrap";

import trash_img from '../../../assets/images/trash.svg'
import add_img from '../../../assets/images/add.svg'

import correct_img from '../../../assets/images/questions/correct.svg'
import wrong_img from '../../../assets/images/questions/wrong.svg'
import missing_img from '../../../assets/images/questions/missing.svg'

export default function ExamSettings (props) {

     const t = useSelector(selectTranslations)

    const handleUpdateData = (e) => {
        const target = e.target
        const name = target.name
        const value = target.type === "checkbox" ? target.checked : target.value
        props.onExamDataChange({
            ...props.examData,
            [name]: value === "null" ? null : value
        })
    }

    const handleUpdateModuleData = (e) => {
        const target = e.target
        const name = target.name
        const value = target.type === "checkbox" ? target.checked : target.value
        let _modules = structuredClone(props.examData?.modules)
        _modules[0]={
            ..._modules[0],
            [name]: e.target.value
        }
        props.onExamDataChange({
            ...props.examData,
            modules: _modules
        })
    }

    const addThreshold = () => {
        props.onExamDataChange({
            ...props.examData,
            thresholds: [...props.examData?.thresholds || [], {
                threshold_name: "",
                is_showable: true,
                score: 0,
                threshold_type: "standard_threshold"
            }]
        })
    }

    const removeThreshold = (index) => {
        let _thresholds = structuredClone(props.examData?.thresholds)
        _thresholds.splice(index, 1)
        props.onExamDataChange({
            ...props.examData,
            thresholds: _thresholds
        })
    }

    const handleUpdateThresholdsData = (e, index) => {
        const target = e.target
        const name = target.name
        const value = target.type === "checkbox" ? target.checked : target.value
        let _thresholds = structuredClone(props.examData?.thresholds)
        _thresholds[index]={
            ..._thresholds[index],
            [name]: value
        }
        props.onExamDataChange({
            ...props.examData,
            thresholds: _thresholds
        })
    }
 
    return (
        <div className='exams-step-6'>
            <div className="info_card">
                <h2>{t.exam.time}*</h2>
                <div className='row'>
                    <div className='col-6'>
                        <Form.Group controlId="time_selector" >
                            <Form.Select className='minw-0' name="time" onChange={handleUpdateData}
                                value={
                                    props?.examData.time ? "" : (props?.examData.time !== null && props?.examData?.modules?.length > 1 ? "null" : "")
                                }
                            >
                                <option value="">{t.exam.exam_time}</option>
                                <option value="null">{t.exam.modules_time}</option>
                            </Form.Select>
                        </Form.Group>
                    </div>
                    {
                        props.examData.time !== "null" || props?.examData?.modules?.length === 1 ?
                        <div className='col-3'>
                            <InputGroup >
                                <Form.Control className='minw-0' type="number" value={props.examData?.time || ''} name="time" onChange={handleUpdateData} />
                                <InputGroup.Text>min</InputGroup.Text>
                            </InputGroup>
                        </div> : null
                    }
                </div>
            </div>
            <div className="info_card">
                <h2>{t.exam.answer_points}</h2>
                {
                    props.examData.modules?.length === 1 ?
                    <div className='row'>
                        <div className='col-3 d-flex align-items-center'>
                            <img src={correct_img} alt='' />
                            <span>Corrette</span>
                            <InputGroup >
                                <Form.Control className='minw-0 ms-2' type="number" step="any" value={props.examData?.modules[0]?.correct_answer_score || ''} name="correct_answer_score" onChange={handleUpdateModuleData} />
                                <InputGroup.Text>pt</InputGroup.Text>
                            </InputGroup>
                        </div>
                        <div className='col-3 d-flex align-items-center'>
                            <img src={missing_img} alt='' />
                            <span>Omesse</span>
                            <InputGroup >
                                <Form.Control className='minw-0 ms-2' type="number" step="any" value={props.examData?.modules[0]?.omitted_answer_score || ''} name="omitted_answer_score" onChange={handleUpdateModuleData} />
                                <InputGroup.Text>pt</InputGroup.Text>
                            </InputGroup>
                        </div>
                        <div className='col-3 d-flex align-items-center'>
                            <img src={wrong_img} alt='' />
                            <span>Sbagliate</span>
                            <InputGroup >
                                <Form.Control className='minw-0 ms-2' type="number" step="any" value={props.examData?.modules[0]?.wrong_answer_score || ''} name="wrong_answer_score" onChange={handleUpdateModuleData} />
                                <InputGroup.Text>pt</InputGroup.Text>
                            </InputGroup>
                        </div>
                    </div> : 
                    <div>
                        <p className='text-center'>{t.exam.multiple_modules_created}</p>
                    </div>
                }
            </div>
            <div className="info_card">
                <h2>{t.exam.treshholds}</h2>
                {
                    props.examData?.thresholds?.map((treshhold, index)=>{
                        return(
                            <div className='d-flex align-items-center mb-2 pb-2 border-bottom flex-wrap'>
                                <Form.Group controlId="description" className=''>
                                    <Form.Label>{t.exam.name}</Form.Label>
                                    <Form.Control className='' type="text" value={treshhold.threshold_name || ''} name="threshold_name" onChange={(e)=>handleUpdateThresholdsData(e,index)} />
                                </Form.Group>
                                <Form.Group controlId="description" className='ms-2'>
                                    <Form.Label>{t.exam.points_to_get}</Form.Label>
                                    <InputGroup >
                                        <Form.Control className='minw-0 ms-2' type="number" step="any" value={treshhold.score || ''} name="score" onChange={(e)=>handleUpdateThresholdsData(e,index)} />
                                        <InputGroup.Text>pt</InputGroup.Text>
                                    </InputGroup>
                                </Form.Group>
                                <Form.Group controlId="type" className='ms-2'>
                                    <Form.Label>{t.exam.threshold_type}</Form.Label>
                                    <Form.Select value={treshhold.threshold_type} style={{maxWidth:'25%'}} name='threshold_type' onChange={(e)=>handleUpdateThresholdsData(e,index)}>
                                        <option disabled>Seleziona</option>
                                        <option value="standard_threshold">Standard</option>
                                        <option value="certificate_generation">Generazione Certificato</option>
                                        <option value="esse3_passing_score_threshold">ESSE3 - Soglia superamento</option>
                                        <option value="esse3_add_to_libretto_threshold">ESSE3 - Aggiungi a libretto</option>
                                        <option value="subject_passing_score_threshold">Soglia superamento per materia</option>
                                        <option value="add_to_group_threshold">Aggiungi al gruppo</option>
                                    </Form.Select>
                                </Form.Group>
                                <Form.Group controlId={'is_showable'} className='ms-2 d-flex align-items-center'>
                                    <Form.Check
                                        type='switch'
                                        id={`is_showable_${index}`}
                                        name='is_showable'
                                        label={'Mostrabile'}
                                        onChange={(e)=>handleUpdateThresholdsData(e,index)}
                                        checked={treshhold?.is_showable || false}
                                    />
                                </Form.Group>
                                {
                                    treshhold.threshold_type === 'certificate_generation' ? (
                                        <>
                                            <Form.Group controlId='pdf_certificate_template_url' className='ms-2'>
                                                <Form.Label>PDF Template URL</Form.Label>
                                                <Form.Control className='' type='text' value={treshhold.pdf_certificate_template_url || ''} name='pdf_certificate_template_url' onChange={(e)=>handleUpdateThresholdsData(e,index)} />
                                            </Form.Group>
                                            <Form.Group controlId='show_scores' className='ms-2 d-flex align-items-center'>
                                                <Form.Check
                                                    type='switch'
                                                    id={`show_scores_${index}`}
                                                    name='show_scores'
                                                    label={'Mostra punteggi'}
                                                    onChange={(e)=>handleUpdateThresholdsData(e,index)}
                                                    checked={treshhold?.show_scores !== false}
                                                />
                                            </Form.Group>
                                            <Form.Group controlId='show_title' className='ms-2 d-flex align-items-center'>
                                                <Form.Check
                                                    type='switch'
                                                    id={`show_title_${index}`}
                                                    name='show_title'
                                                    label={'Mostra titolo'}
                                                    onChange={(e)=>handleUpdateThresholdsData(e,index)}
                                                    checked={treshhold?.show_title !== false}
                                                />
                                            </Form.Group>
                                        </>
                                    ) : null
                                }
                                {
                                    treshhold.threshold_type === 'esse3_passing_score_threshold' ? (
                                        <Form.Group controlId='ad_cod' className='ms-2'>
                                            <Form.Label>AD COD</Form.Label>
                                            <Form.Control className='' type='text' value={treshhold.ad_cod || ''} name='ad_cod' onChange={(e)=>handleUpdateThresholdsData(e,index)} />
                                        </Form.Group>
                                    ) : null
                                }
                                {
                                    treshhold.threshold_type === 'esse3_add_to_libretto_threshold' ? (
                                        <>
                                            <Form.Group controlId='ad_cod' className='ms-2'>
                                                <Form.Label>AD COD</Form.Label>
                                                <Form.Control className='' type='text' value={treshhold.ad_cod || ''} name='ad_cod' onChange={(e)=>handleUpdateThresholdsData(e,index)} />
                                            </Form.Group>
                                            <Form.Group controlId='ad_des' className='ms-2'>
                                                <Form.Label>AD DES</Form.Label>
                                                <Form.Control className='' type='text' value={treshhold.ad_des || ''} name='ad_des' onChange={(e)=>handleUpdateThresholdsData(e,index)} />
                                            </Form.Group>
                                            <Form.Group controlId='cds_id' className='ms-2'>
                                                <Form.Label>CDS ID</Form.Label>
                                                <Form.Control className='' type='number' value={treshhold.cds_id || ''} name='cds_id' onChange={(e)=>handleUpdateThresholdsData(e,index)} />
                                            </Form.Group>
                                            <Form.Group controlId='cds_cod' className='ms-2'>
                                                <Form.Label>CDS COD</Form.Label>
                                                <Form.Control className='' type='text' value={treshhold.cds_cod || ''} name='cds_cod' onChange={(e)=>handleUpdateThresholdsData(e,index)} />
                                            </Form.Group>
                                            <Form.Group controlId='pds_id' className='ms-2'>
                                                <Form.Label>PDS ID</Form.Label>
                                                <Form.Control className='' type='number' value={treshhold.pds_id || ''} name='pds_id' onChange={(e)=>handleUpdateThresholdsData(e,index)} />
                                            </Form.Group>
                                            <Form.Group controlId='pds_cod' className='ms-2'>
                                                <Form.Label>PDS COD</Form.Label>
                                                <Form.Control className='' type='text' value={treshhold.pds_cod || ''} name='pds_cod' onChange={(e)=>handleUpdateThresholdsData(e,index)} />
                                            </Form.Group>
                                            <Form.Group controlId='add_when_passed' className='ms-2 d-flex align-items-center'>
                                                <Form.Check
                                                    type='switch'
                                                    id={`add_when_passed_${index}`}
                                                    name='add_when_passed'
                                                    label={'Aggiungi se superata'}
                                                    onChange={(e)=>handleUpdateThresholdsData(e,index)}
                                                    checked={treshhold?.add_when_passed || false}
                                                />
                                            </Form.Group>
                                        </>
                                    ) : null
                                }
                                {
                                    treshhold.threshold_type === 'subject_passing_score_threshold' ? (
                                        <Form.Group controlId='subject_id' className='ms-2'>
                                            <Form.Label>Subject ID</Form.Label>
                                            <Form.Control className='' type='text' value={treshhold.subject_id || ''} name='subject_id' onChange={(e)=>handleUpdateThresholdsData(e,index)} />
                                        </Form.Group>
                                    ) : null
                                }
                                {
                                    treshhold.threshold_type === 'add_to_group_threshold' ? (
                                        <Form.Group controlId='group_id' className='ms-2'>
                                            <Form.Label>Group ID</Form.Label>
                                            <Form.Control className='' type='text' value={treshhold.group_id || ''} name='group_id' onChange={(e)=>handleUpdateThresholdsData(e,index)} />
                                        </Form.Group>
                                    ) : null
                                }
                                <img src={trash_img} className='ms-2' onClick={()=>removeThreshold(index)} />
                            </div>
                        )
                    })
                }
                <button onClick={addThreshold}>
                    <img src={add_img} alt='' />
                    {t.exam.add_threshold}
                </button>
            </div>
            <>
            </>
        </div>
        
    )
}